export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BibModal.vue?vue&type=template&id=aef9ecbc&"


//////////////////
// WEBPACK FOOTER
// ./src/components/BibModal.vue?vue&type=template&id=aef9ecbc&
// module id = 547
// module chunks = 0